import { render, staticRenderFns } from "./ModalTabelaReservas.vue?vue&type=template&id=1736d72b"
import script from "./ModalTabelaReservas.vue?vue&type=script&lang=js"
export * from "./ModalTabelaReservas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports